export default __webpack_public_path__ + "static/media/violet-triangle.cb5e2164.svg";